<template>
    <div ref="chartContainer" v-bind="$attrs">
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import * as echarts from 'echarts'

const chartContainer = ref(null)

const props = defineProps({
    options: {
        type: Object,
        default: {
            title: {
                text: ''
            },
            xAxis: {
                type: 'category',
                data: ['', '', '', '', '', '']
            },
            color: ["#00FFAF", "#DCAB2E", "#0085FF", "#EB00FF"],
            series: [
                {
                name: '',
                type: 'line',
                data: [5, 20, 36, 10, 10, 20]
                }
            ]
        }
    }
})

let myChart = null

onMounted(() => {
    props.options.grid = { top: 30, left: 0, right: 0, bottom: 0}
    props.options.tooltip = {
        ...props.options.tooltip,
        confine: true,
        backgroundColor: '#1a1a19E6',
        borderColor: "#FFFFFF50",
        textStyle: {
            color: 'white'
        }
    }
    props.options.color = ["#00FFAF", "#DCAB2E", "#0085FF", "#EB00FF"]
    props.options.yAxis = {
        ...props.options.yAxis,
        type: 'value',
        axisLabel: {
            color: 'white',
            formatter: function (value) {
                // Mostra solo interi come label
                return Number.isInteger(value) ? value : ''
            }
        },
        splitLine: {
            lineStyle: {
                color: '#FFFFFF50'
            }
        }
    },
    props.options.xAxis = {
        ...props.options.xAxis,
        axisLabel: {
            color: 'white'
        }
    }
    myChart = echarts.init(chartContainer.value)
    myChart.setOption(props.options)
})

watch(
    () => props.options,
    () => myChart.setOption(props.options),
    { deep: true }
)
</script>